const mainElemCSSPath = '.top-panel_select-for-shopping-cart';
const stepsCSSPath = `${mainElemCSSPath} .top-panel__title-steps`;
const selectedTitleCSSPath = `${mainElemCSSPath} .top-panel__title-center .top-panel__menu-text`;
const selectedSubtitleCSSPath = `${mainElemCSSPath} .top-panel__title-center .top-panel__menu-subtext`;

const getTextForSteps = (amount, total) => `Step ${amount} of ${total}`;
const getTextForSelect = (amount) => {
  if (Number.isFinite(amount)) {
    return `Select up to ${amount} image(s)`;
  }
  return `Select up as many images as you want`;
};
const getTextForTarget = (name) => `for "${name}"`;

export function initTopPanelSelectForShoppingCart() {
  return {
    setSteps,
    setSelectedImageTitle,
    setNameOfTarget,
  };

  function setSteps(amount, total) {
    if (total > 1) {
      const $elem = document.querySelector(stepsCSSPath);
      $elem.innerHTML = getTextForSteps(amount, total);
    }
  }

  function setSelectedImageTitle(amount) {
    const $elem = document.querySelector(selectedTitleCSSPath);
    $elem.innerHTML = getTextForSelect(amount);
  }

  function setNameOfTarget(name) {
    const $elem = document.querySelector(selectedSubtitleCSSPath);
    $elem.innerHTML = getTextForTarget(name);
  }
}
